export default __webpack_public_path__ + "static/media/SReloj.91ad2dc4.svg";